import { CoreApi, ProductType, PartKey } from '@inter-ikea-storageone/range';
import { LightsArrangement } from '../types/LightsArrangement';
import { ComponentIds, Entity, ProductPartComponent } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';

const getLightsArrangement: (selectedEntity: Entity, coreApi: CoreApi) => LightsArrangement = (
  selectedEntity,
  coreApi
) => {
  if (
    coreApi.entities.isProductType(selectedEntity, ProductType.PAX_INNER_LIGHT) ||
    coreApi.entities.isProductType(selectedEntity, ProductType.PAX_INNER_LIGHT_OVERSIDAN)
  ) {
    return LightsArrangement.None;
  }

  const frame = coreApi.entities.getParent(selectedEntity);

  if (frame) {
    const cornerFrame =
      frame.getComponent<ProductPartComponent>(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey ===
      PartKey.CORNER_SOLUTION_NORMAL_FRAME;

    if (cornerFrame) {
      return LightsArrangement.None;
    }

    const size = frame.getComponent<CommunicationSizeComponent>(
      ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
    )?.size;
    if (size?.width === 500) {
      return LightsArrangement.None;
    }

    const lights = coreApi.entities.getChildrenWithProductType(frame, ProductType.PAX_OUTER_LIGHT);

    if (lights.length > 1) {
      return LightsArrangement.Double;
    } else {
      return LightsArrangement.Single;
    }
  }
  return LightsArrangement.None;
};

export default getLightsArrangement;
